<template>
    <div>
        <v-snackbar
            center
            dark
            :timeout="-1"
            v-model="showSnackBar"
            >
            <v-row
                class="d-flex align-center justify-space-between text-center"
                no-gutters
                v-if="loadingDocuments"
            >
                <v-col class="d-flex align-center" cols="auto">
                    <v-icon color="green lighten-2" class="mr-2">
                        mdi-progress-check
                    </v-icon>
                    <span> {{ $t("Site.DocumentRecognition.DraggedDocuments").replace("{0}", documentsCount) }} </span>
                </v-col>

                <v-col class="d-flex justify-end" cols="auto">
                    <v-btn dark icon @click="showSnackBar = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-col>
            </v-row>

            <v-progress-linear
                indeterminate
                color="yellow darken-2"
                class="mt-2"
                v-if="loadingDocuments"
            />

            <v-row
                class="d-flex align-center justify-space-between text-center"
                no-gutters
                v-if="hasFailedDocuments"
            >
                <v-col class="d-flex align-center" cols="auto">
                    <v-icon color="red accent-4" class="mr-2">
                        mdi-text-box-remove-outline
                    </v-icon>
                    <span> {{ $t("Site.DocumentRecognition.DraggedDocumentsFailed").replace("{0}", failedDocumentsCount) }}</span>
                </v-col>

                <v-col class="d-flex justify-end" cols="auto">
                    <v-btn dark icon @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-col>
            </v-row>

            <v-btn
                v-if="hasFailedDocuments"
                block
                color="error"
                small
                @click="showItemsFailed = true"
            >
                {{ $t("ViewDocuments") }}</v-btn>

        </v-snackbar>
        <v-navigation-drawer
            v-model="showItemsFailed"
            right
            temporary
            app
            class="elevation-3"
            width="400"
        >
            <v-toolbar flat color="white">
            <v-toolbar-title class="headline ml-3"> {{ $t("Site.DocumentRecognition.NoDocumentsLoaded") }} </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="showItemsFailed = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            </v-toolbar>

            <v-divider></v-divider>

            <v-container>
                <v-card
                class="d-flex align-center pa-2 my-2"
                v-for="item in documentsFailed"
                :key="item.upload.uuid"
                >
                <v-icon color="red accent-4 mr-2">
                    mdi-text-box-remove-outline
                </v-icon>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <span class="px-3" v-on="on">
                            {{ item.name }}

                            <small class="grey--text caption d-block">
                                {{ $t("Error") }}: {{ item.errorMessage }}
                            </small>
                        </span>
                    </template>
                    <span>{{ item.name }}</span>
                </v-tooltip>
                <v-btn icon @click="removeItem(item)">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                </v-card>
            </v-container>
        </v-navigation-drawer>

    </div>
</template>
<script>

export default {
    props: {
        showDocumentsDraggedToast: {
            type: Boolean,
            default: false
        },
        documentsCount: {
            type: Number,
            default: 0
        },
        draggedDocumentsFailed: {
            type: Array,
            default: () => []
        }
    },
    watch: {
        showDocumentsDraggedToast(val) {
            this.showSnackBar = val;
            this.loadingDocuments = val;
        },
        draggedDocumentsFailed(val) {
            const hasFailures = val.length > 0;

            this.showSnackBar = hasFailures;
            this.hasFailedDocuments = hasFailures;
            this.failedDocumentsCount = val.length;
            this.loadingDocuments = !hasFailures;
            this.documentsFailed = val;
        }

    },
    data() {
        return {
            showSnackBar: false,
            showItemsFailed: false,
            loadingDocuments: false,
            hasFailedDocuments: false,
            failedDocumentsCount: 0,
            documentsFailed: [],
        };
    },
    methods: {
        close() {
            this.showSnackBar = false;
            this.showItemsFailed = false;
            this.loadingDocuments = false;
            this.hasFailedDocuments = false;
            this.failedDocumentsCount = 0;
            this.documentsFailed = [];
            this.$emit('close');
        },
        removeItem(item) {
            this.documentsFailed = this.documentsFailed.filter(x => x.upload.uuid !== item.upload.uuid);
            this.$emit('remove-item', item.upload.uuid);
        }
    }
};
</script>
